import '../style/flyover.css';
import { motion, useScroll, useTransform, useInView, useAnimation } from "framer-motion";
function Flyover({toggleEnableChatbot}) {
    const itemVariants = {
      hidden: { opacity: 0, y: 20 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
    };
    return ( 
        <div className='rounded-3xl overflow-hidden'>
            <section class="section top-section">
                <div class="content-container content-theme-dark">
                <div class="content-inner">
                    <div class="content-center">
                    <p> Meet </p>
                    <h1>Pence Bot</h1>
                    <p> Want to learn more about me ?</p>
                    </div>
                </div>
                </div>
            </section>

            <section class="section bottom-section">
                <div class="content-container content-theme-light">
                <div class="content-inner">
                    <div class="content-center">
                    <h1>Pence Bot</h1>
                    <p> Chat with an AI-powered bot that knows all about my background, skills, and projects — built by me, for you. </p>
                    <p> Powered by Retrieval-Augmented Generation (RAG) and LangGraph, deployed on Hugging Face, and hosted on AWS with a custom React frontend.</p>
                        <motion.button
                            onClick={() => toggleEnableChatbot()}
                            className="bg-blue-600 text-white px-4 py-2 mt-4 rounded hover:bg-blue-700 transition"
                            variants={itemVariants}
                            whileHover={{ scale: 1.05, boxShadow: "0 0 12px rgba(59,130,246,0.8)" }}
                            whileTap={{ scale: 0.95 }}
                            >
                            Try It Now
                        </motion.button>
                    </div>
                </div>
                </div>
            </section>
        </div>
     );
}

export default Flyover;